import { useAppSelector } from 'hooks/hooks'
import { useCurrentCountry } from 'hooks/miscHooks'
import ReportExportButton from './common/ReportExportButton'
import ReportPageTemplate from './common/ReportPageTemplate'
import WinBackOffersReportAnalytics from './WinBackOffersReportAnalytics'
import WinBackOffersReportFilter from './WinBackOffersReportFilter'
import WinBackOffersReportList from './WinBackOffersReportList'

const WinBackOffersReportPage = () => {
    const country = useCurrentCountry()
    const { filters } = useAppSelector((state) => state.winBackOffersReport)

    return (
        <ReportPageTemplate
            title="Win-Back Offers Report"
            description="Analysis of win-back offer effectiveness by segment and offer variant"
            exportButton={
                <ReportExportButton
                    exportEndpoint="office/win-back-offers-report/export"
                    filters={filters}
                    country={country}
                />
            }
            analyticsComponent={<WinBackOffersReportAnalytics />}
            filterComponent={<WinBackOffersReportFilter />}
            listComponent={<WinBackOffersReportList />}
        />
    )
}

export default WinBackOffersReportPage
